// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-main-div {
  width: 100%;
}

.input-div {
  display: flex;
  justify-content: center;
  flex-direction: column;
  /* padding: 5px; */
  margin-bottom: 5px;
  color: #405261;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.input-new {
  width: 100%;
  flex-shrink: 0;
  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  padding: 13px 16px;
  outline: none;
  height: 40px;
  font-weight: 400;
  font-size: 14px;
  font-family: "Inter";
  line-height: 40px;
  font-style: normal;
}

.input-new:hover {
  border-color: #a9b0b6;
}

.input-new:focus {
  border-color: #148dfd;
  box-shadow: 0 0 2px #148dfd;
}
.form-control {
  height: 40px !important;
  width: 100% !important;
  border: 1px solid #d5dce1 !important;
  border-radius: 8px !important;
  font-size: 14px !important;
  font-style: normal !important;
  font-weight: 400 !important;
  line-height: normal !important;
  transition: none !important;
  outline: none !important;
}

.form-control::placeholder {
  color: #c5ced6 !important;
}
.input-new-01 {
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  padding: 13px 16px;
  outline: none;
}
.input-new::placeholder {
  color: #c5ced6;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;

  font-family: Inter;
}

.footer__trust {
  width: 100%;
  display: flex;
  justify-content: space-between;
  border: none;
  outline: none;
  padding: 24px 24px;
}
.trust__01 {
  color: #556575;

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
}
.rowcount {
  display: flex;
  flex-direction: row;
  width: 100%;
  margin: auto;
  margin-top: 8px;
  align-items: center;
  gap: 24px;
}

.blockk {
  display: flex;
  background: #ffffff;
  border: 1px solid #e2e2ea;
  box-sizing: border-box;
  border-radius: 10px;
  width: 80px;
  height: 40px;
  align-items: center;
  text-align: center;
  justify-content: center;
}
.count {
  color: #061522;

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  align-items: center;
  text-align: center;
  justify-content: center;
  color: #222254;
  margin-bottom: 0;
  width: 100%;
  outline: none;
  caret-color: transparent;
  border: none;
}
.Input-headingcontainer {
  width: 100%;
  display: flex;
  justify-content: space-between;
  /* flex-direction: row; */
}
.headingcontainer__textInput {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.btn-div {
  display: flex;
  justify-content: center;
  align-items: center;
  /* padding-top: 11px; */
  padding-bottom: 8px;
}

.buttonStyle {
  border-radius: 8px;
  border: 1px solid #c5ced6;
  background: #f9fafa;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  width: 368px;
  height: 40px;
  color: #405261;

  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 128.571% */
  cursor: pointer;
}
.buttonStyle:not(:disabled):hover {
  background-color: #0077cc;

  outline: none;
}

.Team-PopUp-Container-Common {
  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 15px 20px 0px rgba(6, 21, 34, 0.05);
  padding: 32px;
  max-width: 500px;
  width: min(90vw, 500px);
  height: auto;
  max-height: calc(100vh - 32px);
  overflow-y: auto;
  z-index: 1201;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.buttonStyleDisabled {
  background: #f9fafa;
  color: #93a1b0;
  border-color: #c5ced6;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 128.571% */
  cursor: not-allowed;
}
.buttonStyleEnable {
  background: #148dfd;
  border-radius: 8px;
  color: #fff;

  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 128.571% */
}
.count:focus {
  animation: blink 1s step-end infinite;
}
.InputErrorMsg {
  display: flex;
  justify-content: flex-start;
  color: #ff4d4f;

  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding-top: 5px;
}
.Select-number {
  color: #556575;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  font-family: Inter, sans-serif;
  border-radius: 4px;
  height: 32px;
  margin-top: 5px;
  margin-left: 8px;
  margin-right: 8px;
  padding: 0 8px !important;
}

.Select-number:hover {
  color: #061522;
  border-radius: 8px;
  background: #f9fafa;
}

.Select-number.Mui-selected {
  background-color: #f9fafa !important;
  color: #061522;
}
.buttonUploadStyle {
  display: flex;
  justify-content: flex-start;
  width: 100%;
  /* height: 40px; */
  flex-shrink: 0;
  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  padding: 10px 16px;
  outline: none;
  text-transform: capitalize;
  margin-top: 8px;
  color: #405261;

  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.BrowserText {
  position: absolute;
  right: 20px;
  color: #148dfd;
  text-align: right;

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration-line: underline;
  text-transform: capitalize;
}

.main_lead_container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 25px 24px;
  width: 100%;
  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  cursor: pointer;
  margin: 0px 0px 8px 0px;
}
.Increase_lead {
  color: #061522;

  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
}
.save_details {
  color: #556575;

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
}
.activeDiv {
  display: flex;
  flex-direction: column;
  padding: 25px 24px;
  width: 100%;
  border-radius: 8px;
  border-radius: 8px;
  border: 1px solid #148dfd;
  background: #f3fbff;
  box-shadow: 0px 1px 2px 0px rgba(20, 141, 253, 0.1);
  cursor: pointer;
}

.input__textfield {
  width: 100%;
  /* height: 40px; */
  flex-shrink: 0;
  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  padding: 13px 16px;
  outline: none;
}

@media screen and (max-width: 550px) {
  .footer__trust {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #777777;
    border: none;
    outline: none;
    padding: 10px 5px;
  }
  .buttonStyle {
    width: 100%;
  }

  .blockk {
    width: 44px;
    height: 64px;
  }
}

.Successful-Container {
  display: flex;
  justify-content: center;
  align-items: center;
}
.Succes_static_text {
  color: #061522;
  text-align: center;

  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 111.111% */
}
.Succes_static_discreption {
  color: #556575;
  text-align: center;

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
}
.Success_static_container {
  margin-top: 34px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 16px;
}
.bplus-icon {
  margin-right: 4px;
  font-size: 1.2em;
  display: inline-flex;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/style.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iDAAiD;EACjD,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,oCAAoC;EACpC,6BAA6B;EAC7B,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;EAC9B,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,iDAAiD;EACjD,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;;EAEhB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,wBAAwB;EACxB,YAAY;AACd;AACA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,iDAAiD;EACjD,YAAY;EACZ,YAAY;EACZ,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,eAAe;AACjB;AACA;EACE,yBAAyB;;EAEzB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,mDAAmD;EACnD,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;;EAEX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iDAAiD;EACjD,kBAAkB;EAClB,aAAa;EACb,0BAA0B;EAC1B,eAAe;EACf,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,iBAAiB;;EAEjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iDAAiD;EACjD,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mDAAmD;EACnD,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iDAAiD;EACjD,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,aAAa;IACb,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,kBAAkB;;EAElB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,cAAc;EACd,kBAAkB;;EAElB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB","sourcesContent":[".input-main-div {\n  width: 100%;\n}\n\n.input-div {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  /* padding: 5px; */\n  margin-bottom: 5px;\n  color: #405261;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.input-new {\n  width: 100%;\n  flex-shrink: 0;\n  border-radius: 8px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  padding: 13px 16px;\n  outline: none;\n  height: 40px;\n  font-weight: 400;\n  font-size: 14px;\n  font-family: \"Inter\";\n  line-height: 40px;\n  font-style: normal;\n}\n\n.input-new:hover {\n  border-color: #a9b0b6;\n}\n\n.input-new:focus {\n  border-color: #148dfd;\n  box-shadow: 0 0 2px #148dfd;\n}\n.form-control {\n  height: 40px !important;\n  width: 100% !important;\n  border: 1px solid #d5dce1 !important;\n  border-radius: 8px !important;\n  font-size: 14px !important;\n  font-style: normal !important;\n  font-weight: 400 !important;\n  line-height: normal !important;\n  transition: none !important;\n  outline: none !important;\n}\n\n.form-control::placeholder {\n  color: #c5ced6 !important;\n}\n.input-new-01 {\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  padding: 13px 16px;\n  outline: none;\n}\n.input-new::placeholder {\n  color: #c5ced6;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n\n  font-family: Inter;\n}\n\n.footer__trust {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  border: none;\n  outline: none;\n  padding: 24px 24px;\n}\n.trust__01 {\n  color: #556575;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 128.571% */\n}\n.rowcount {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  margin: auto;\n  margin-top: 8px;\n  align-items: center;\n  gap: 24px;\n}\n\n.blockk {\n  display: flex;\n  background: #ffffff;\n  border: 1px solid #e2e2ea;\n  box-sizing: border-box;\n  border-radius: 10px;\n  width: 80px;\n  height: 40px;\n  align-items: center;\n  text-align: center;\n  justify-content: center;\n}\n.count {\n  color: #061522;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  align-items: center;\n  text-align: center;\n  justify-content: center;\n  color: #222254;\n  margin-bottom: 0;\n  width: 100%;\n  outline: none;\n  caret-color: transparent;\n  border: none;\n}\n.Input-headingcontainer {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  /* flex-direction: row; */\n}\n.headingcontainer__textInput {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n}\n.btn-div {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  /* padding-top: 11px; */\n  padding-bottom: 8px;\n}\n\n.buttonStyle {\n  border-radius: 8px;\n  border: 1px solid #c5ced6;\n  background: #f9fafa;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  width: 368px;\n  height: 40px;\n  color: #405261;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 128.571% */\n  cursor: pointer;\n}\n.buttonStyle:not(:disabled):hover {\n  background-color: #0077cc;\n\n  outline: none;\n}\n\n.Team-PopUp-Container-Common {\n  border-radius: 8px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 15px 20px 0px rgba(6, 21, 34, 0.05);\n  padding: 32px;\n  max-width: 500px;\n  width: min(90vw, 500px);\n  height: auto;\n  max-height: calc(100vh - 32px);\n  overflow-y: auto;\n  z-index: 1201;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n.buttonStyleDisabled {\n  background: #f9fafa;\n  color: #93a1b0;\n  border-color: #c5ced6;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 128.571% */\n  cursor: not-allowed;\n}\n.buttonStyleEnable {\n  background: #148dfd;\n  border-radius: 8px;\n  color: #fff;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 128.571% */\n}\n.count:focus {\n  animation: blink 1s step-end infinite;\n}\n.InputErrorMsg {\n  display: flex;\n  justify-content: flex-start;\n  color: #ff4d4f;\n\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  padding-top: 5px;\n}\n.Select-number {\n  color: #556575;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  font-family: Inter, sans-serif;\n  border-radius: 4px;\n  height: 32px;\n  margin-top: 5px;\n  margin-left: 8px;\n  margin-right: 8px;\n  padding: 0 8px !important;\n}\n\n.Select-number:hover {\n  color: #061522;\n  border-radius: 8px;\n  background: #f9fafa;\n}\n\n.Select-number.Mui-selected {\n  background-color: #f9fafa !important;\n  color: #061522;\n}\n.buttonUploadStyle {\n  display: flex;\n  justify-content: flex-start;\n  width: 100%;\n  /* height: 40px; */\n  flex-shrink: 0;\n  border-radius: 8px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  padding: 10px 16px;\n  outline: none;\n  text-transform: capitalize;\n  margin-top: 8px;\n  color: #405261;\n\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.BrowserText {\n  position: absolute;\n  right: 20px;\n  color: #148dfd;\n  text-align: right;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  text-decoration-line: underline;\n  text-transform: capitalize;\n}\n\n.main_lead_container {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 25px 24px;\n  width: 100%;\n  border-radius: 8px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  cursor: pointer;\n  margin: 0px 0px 8px 0px;\n}\n.Increase_lead {\n  color: #061522;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px; /* 142.857% */\n}\n.save_details {\n  color: #556575;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px; /* 142.857% */\n}\n.activeDiv {\n  display: flex;\n  flex-direction: column;\n  padding: 25px 24px;\n  width: 100%;\n  border-radius: 8px;\n  border-radius: 8px;\n  border: 1px solid #148dfd;\n  background: #f3fbff;\n  box-shadow: 0px 1px 2px 0px rgba(20, 141, 253, 0.1);\n  cursor: pointer;\n}\n\n.input__textfield {\n  width: 100%;\n  /* height: 40px; */\n  flex-shrink: 0;\n  border-radius: 8px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  padding: 13px 16px;\n  outline: none;\n}\n\n@media screen and (max-width: 550px) {\n  .footer__trust {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    color: #777777;\n    border: none;\n    outline: none;\n    padding: 10px 5px;\n  }\n  .buttonStyle {\n    width: 100%;\n  }\n\n  .blockk {\n    width: 44px;\n    height: 64px;\n  }\n}\n\n.Successful-Container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.Succes_static_text {\n  color: #061522;\n  text-align: center;\n\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px; /* 111.111% */\n}\n.Succes_static_discreption {\n  color: #556575;\n  text-align: center;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px; /* 142.857% */\n}\n.Success_static_container {\n  margin-top: 34px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  gap: 16px;\n}\n.bplus-icon {\n  margin-right: 4px;\n  font-size: 1.2em;\n  display: inline-flex;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
